import RefreshIconSvg from '../../assets/icons/refresh.svg?react';
import type { CSSProperties } from 'react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const RefreshIcon: React.FC<IconProps> = ({ 
    size = 16, 
    className = '', 
    style = {},
    onClick 
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return (
        <RefreshIconSvg 
            className={className}
            style={iconStyle}
            onClick={onClick}
        />
    );
};

export default RefreshIcon;
